module.exports = __webpack_public_path__ + "assets/img/1d5006cdc005f7b278050267d41599a1.webp";